<template>
	<div>
        <div class="columns">
            <div class="column">
                <p class="title is-6 mt-2 mb-1">Angle Settings</p>
                <div class="up-input-group">
                    <up-numberinput
                    v-model="cut_spinner.circle_angle"
                    size="sm"
                    label="Circle Angle"
                    ></up-numberinput>
                    <up-numberinput
                    v-model="cut_spinner.spinner_angle"
                    size="sm"
                    label="Spinner Angle"
                    ></up-numberinput>
                </div>    
            </div>
            <div class="column">
                <p class="title is-6 mt-2 mb-1">Circle Styles</p>
                <div class="up-input-group">
                    <up-textinput
                        v-model="cut_spinner.arc1_styles.bg_color"
                        size="sm"
                        label="Color 1"
                    ></up-textinput>
                    <up-textinput
                        v-model="cut_spinner.arc2_styles.bg_color"
                        size="sm"
                        label="Color 2"
                    ></up-textinput>
                    <up-numberinput
                        v-model="cut_spinner.stroke_width"
                        size="sm"
                        label="Stroke Width"
                        labelIcon="mdi mdi-alpha-w-box-outline"
                    ></up-numberinput>
                </div>
            </div>
            <div class="column">
                <style-editor
                    title="Box"
                    show_width 
                    show_height
                    v-model="cut_spinner.box_styles"
                ></style-editor>
            </div>
        </div>    
        <show-cut-spinner :cut_spinner="cut_spinner"></show-cut-spinner>
    </div>
</template>
<script>
import StyleEditor from '@/components/Common/StyleEditor/StyleEditor'
import UpNumberinput from '@/components/UI/Inputs/UpNumberinput'
import { defaultCutSpinnerValue } from "./utils";
import ShowCutSpinner from '@/components/Question/CutSpinner/ShowCutSpinner'
import UpTextinput from "@/components/UI/Inputs/UpTextinput";

export default {
	name : 'set-cut-spinner',
	components : {
		StyleEditor,
        UpNumberinput,
        ShowCutSpinner,
        UpTextinput
	},
	props : {
		value : {
			type : Object,
		}
	},
	data(){
		return {
            cut_spinner: this.value ? this.value : defaultCutSpinnerValue(),
		}
	},
    watch: {
        cut_spinner: {
        handler: function (new_val) {
            this.$emit("input", new_val);
        },
        deep: true,
        },
        value: {
        handler: function (new_val) {
            this.cut_spinner = new_val;
        },
        deep: true,
        },
    },
}
</script>